export default "__VITE_ASSET__CbUvfJaR__"